
    import './styles.scoped.css';
    export default {
  "selectable-item": "awsui_selectable-item_15o6u_1aok0_93",
  "pad-bottom": "awsui_pad-bottom_15o6u_1aok0_113",
  "has-background": "awsui_has-background_15o6u_1aok0_122",
  "highlighted": "awsui_highlighted_15o6u_1aok0_125",
  "selected": "awsui_selected_15o6u_1aok0_125",
  "disabled": "awsui_disabled_15o6u_1aok0_139",
  "next-item-selected": "awsui_next-item-selected_15o6u_1aok0_149",
  "is-keyboard": "awsui_is-keyboard_15o6u_1aok0_157",
  "parent": "awsui_parent_15o6u_1aok0_160",
  "interactiveGroups": "awsui_interactiveGroups_15o6u_1aok0_164",
  "child": "awsui_child_15o6u_1aok0_176",
  "virtual": "awsui_virtual_15o6u_1aok0_191",
  "measure-strut": "awsui_measure-strut_15o6u_1aok0_202",
  "measure-strut-first": "awsui_measure-strut-first_15o6u_1aok0_211",
  "screenreader-content": "awsui_screenreader-content_15o6u_1aok0_215",
  "option-content": "awsui_option-content_15o6u_1aok0_221"
};
  